export default (theme) => ({
    messageContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexWrap: "wrap",
        boxSizing: "border-box",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center"
    },
    message: {
        "& h4": {
            color: theme.palette.primary.main,
            margin: theme.spacing(1)
        }
    }
});
